import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Auth from './pages/Auth';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import Numerisation from './pages/Numerisation';
import Decisions from './pages/Decisions';
import DecisionDetail from './pages/DecisionDetail';
import Recherche from './pages/Recherche';
import AdminDashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import Historique from './pages/Historique';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirect root to login */}
        <Route path="/" element={<Navigate to="/connexion" replace />} />

        {/* Auth routes - full page without layout */}
        <Route path="/connexion" element={<Auth />} />
        <Route path="/inscription" element={<Auth />} />
        <Route path="/mot-de-passe-oublie" element={<Auth />} />
        <Route path="/verification-otp/:type?" element={<Auth />} />

        {/* Espace Agent (CNDJ) */}
        <Route path="/espace-cndj" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="numerisation" element={<Numerisation />} />
          <Route path="decisions" element={<Decisions />} />
          <Route path="decisions/:id" element={<DecisionDetail />} />
          <Route path="recherche" element={<Recherche />} />
        </Route>

        {/* Espace Admin */}
        <Route path="/espace-admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="utilisateurs" element={<Users />} />
          <Route path="historique" element={<Historique />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/connexion" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
